// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit-metric__gauge-chart{border-radius:.2em;height:12px!important;width:78px}.kit-metric__gauge-chart .v-progress-linear__content{filter:contrast(.9);font-size:10px!important;font-weight:600;mix-blend-mode:color-burn}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
